import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  FormHelperText,
  TextField,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Alert,
  Snackbar,
  Autocomplete,
  Table,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,

  IconButton,
  Container,
  CircularProgress
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/material/styles';
import { local_signage, local_url } from '../Const';
import dayjs from 'dayjs';
import { Plus, X } from 'lucide-react';

// Styled components remain the same...
const StyledCard = styled(Card)(({ theme }) => ({
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.spacing(2),
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  }));
  
  const FormContainer = styled(Container)(({ theme }) => ({
    marginTop: theme.spacing(2),
  }));
  




export const UserRegistrationForm = ({ initialData, onClose }) => {

    console.log('---------',initialData);
    
  const userId = localStorage.getItem('userId');
  const [selectionMode, setSelectionMode] = useState(null); // Can be "NEW", "UPDATED", or null

  const [formData, setFormData] = useState({
    userID: '',
    userName: '',
    fatherName: '',
    companyCode: '',
    currentBranchId: '',
    defaultLoginBranchId: '',
    roleCode: '',
    desigCode: '', // Added designationCode

    mobile: '',
    email: '',
    isActive: true,
    dob: null,
    joindate: null,
    area: ''
  });


  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAreaName, setSelectedAreaName] = useState('');
  const [designations, setDesignations] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [designationInputValue, setDesignationInputValue] = useState('');
  const [selectedVehicleIndex, setSelectedVehicleIndex] = useState(null);


  const [areas, setAreas] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchInputValue, setBranchInputValue] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [error, setError] = useState(null);

  const [ledgerData, setLedgerData] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const mobileRegex = /^[0-9]{10}$/;
  
  // Modified vehicle state to match desired payload structure
  const [vehicles, setVehicles] = useState([]);
  const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false);
  const [newVehicleData, setNewVehicleData] = useState({
    vehicleId: '',
    vehicleAlias: '',
    lineNumber: ''
  });
  const [roles, setRoles] = useState([]);

  const [vehicleError, setVehicleError] = useState({});
  const [nextLineNumber, setNextLineNumber] = useState(1); // Store as a number, not 001

  const validateField = (name, value) => {
    switch (name) {
      case 'email':
        // Email is now optional, but if provided, it should be valid
        if (value && !emailRegex.test(value)) return "Invalid email format";
        return "";
      case 'mobile':
        if (!value) return "Mobile number is required";
        if (!mobileRegex.test(value)) return "Mobile number must be exactly 10 digits";
        return "";
      case 'userName':
        if (!value.trim()) return "Name is required";
        return "";
      case 'currentBranchId':
        if (!value) return "Branch is required";
        return "";
        case 'desigCode': // Added validation for designation
        if (!value) return "Designation is required";
        return "";
      case 'roleCode':
        if (!value) return "Role is required";
        return "";
      case 'area':
        if (!value) return "Area is required";
        return "";
      case 'companyCode':
        if (!value) return "Company Code is required";
        return "";
      default:
        return "";
    }
  };




  const handleVehicleCheckboxChange = (index) => {
    // Simply toggle the selected state for this vehicle without mode restriction
    setVehicles(prev => {
      const updatedVehicles = [...prev];
      updatedVehicles[index] = {
        ...updatedVehicles[index],
        selected: !updatedVehicles[index].selected
      };
      return updatedVehicles;
    });
  };




  const handleRemoveVehicle = () => {
    // Check if any NEW vehicles are selected
    const hasSelectedNewVehicles = vehicles.some(vehicle => vehicle.selected && vehicle.dml === "I");
    
    if (hasSelectedNewVehicles) {
      // Filter out selected NEW vehicles
      const removedVehicles = vehicles.filter(vehicle => vehicle.selected && vehicle.dml === "I");
      const remainingVehicles = vehicles.filter(vehicle => !(vehicle.selected && vehicle.dml === "I"));
      
      // Resequence line numbers for all vehicles
      const resequencedVehicles = resequenceLineNumbers(remainingVehicles);
      
      // Update vehicles state
      setVehicles(resequencedVehicles);
      setSelectionMode(null);
      
      // Show success message
      setSnackbar({
        open: true,
        message: 'New vehicles removed successfully!',
        severity: 'success'
      });
    } else {
      // Show message if no NEW vehicles are selected
      setSnackbar({
        open: true,
        message: 'Please select vehicles with NEW status to remove',
        severity: 'info'
      });
    }
  };
  



  const resequenceLineNumbers = (vehicleList) => {
    // Sort by existing line numbers to maintain relative order
    const sortedVehicles = [...vehicleList].sort((a, b) => {
      const aNum = parseInt(a.lineNumber, 10) || 0;
      const bNum = parseInt(b.lineNumber, 10) || 0;
      return aNum - bNum;
    });
    
    // Reassign line numbers in sequence
    return sortedVehicles.map((vehicle, idx) => {
      const newLineNumber = (idx + 1).toString().padStart(3, '0');
      return {
        ...vehicle,
        lineNumber: newLineNumber
      };
    });
  };



  const handleDeleteVehicles = async (e) => {
    e.preventDefault();
    
    // Check if any vehicles are selected
    const hasSelectedVehicles = vehicles.some(vehicle => vehicle.selected);
    
    if (!hasSelectedVehicles) {
      setSnackbar({
        open: true,
        message: 'Please select vehicles to delete',
        severity: 'info'
      });
      return;
    }
    
    // Separate vehicles into categories based on selection and status
    const selectedNewVehicles = vehicles.filter(v => v.selected && v.dml === "I");
    const selectedUpdatedVehicles = vehicles.filter(v => v.selected && v.dml === "E");
    const unselectedVehicles = vehicles.filter(v => !v.selected);
    
    // If no vehicles are selected for API update, just handle frontend removal
    if (selectedUpdatedVehicles.length === 0 && selectedNewVehicles.length > 0) {
      // Handle NEW vehicles - just remove them locally
      const remainingVehicles = [...unselectedVehicles];
      
      // Resequence line numbers for all vehicles
      const resequencedVehicles = resequenceLineNumbers(remainingVehicles);
      
      // Update vehicles state
      setVehicles(resequencedVehicles);
      
      // Show success message
      setSnackbar({
        open: true,
        message: 'New vehicles removed successfully!',
        severity: 'success'
      });
      
      return;
    }
    
    // If we have UPDATED vehicles selected, we need to make an API call
    setLoading(true);
  
    try {
      // Create a payload with both types of vehicles:
      // 1. UPDATED vehicles marked for deletion
      // 2. NEW vehicles not included (they will be dropped from the array)
      // 3. Unselected vehicles remain unchanged
      
      const updatedVehiclesForApi = selectedUpdatedVehicles.map(vehicle => ({
        ...vehicle,
        dml: "D",
        selected: false,
        userId: formData.userID || initialData?.userid
      }));
      
      // Keep unselected vehicles unchanged
      const unchangedVehicles = unselectedVehicles.map(v => ({
        ...v,
        userId: formData.userID || initialData?.userid
      }));
      
      // Combined array for API with updated and unchanged vehicles
      // Note: We intentionally exclude selectedNewVehicles
      const vehiclesForApi = [...updatedVehiclesForApi, ...unchangedVehicles];
      
      // Update the payload
      const payload = {
        ...formData,
        vehicle: vehiclesForApi,
        createdUserId: userId || 'system',
        createdDate: new Date().toISOString(),
        dob: formData.dob?.toISOString(),
        joindate: formData.joindate?.toISOString()
      };
  
      const response = await fetch(`${local_url}/api/User/CreateEditUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('AuthorizationToken')}`
        },
        body: JSON.stringify(payload)
      });
  
      const responseData = await response.json();
  
      if (!response.ok || responseData.result === 0) {
        throw new Error(responseData.description || 'Failed to delete vehicles');
      }
  
      // After successful API call, update the local state
      // For display purposes, we'll remove the NEW vehicles and change status of UPDATED vehicles
      const updatedLocalVehicles = [
        ...unchangedVehicles,
        ...updatedVehiclesForApi
      ];
      
      // Update state
      setVehicles(resequenceLineNumbers(updatedLocalVehicles));
      
      setSnackbar({
        open: true,
        message: responseData.description || 'Vehicles deleted successfully!',
        severity: 'success'
      });
  
      // If you want to close the form after deletion
      setTimeout(() => {
        onClose();
      }, 1000);
    } catch (error) {
      console.error('Error deleting vehicles:', error);
      setSnackbar({
        open: true,
        message: error.message || 'Failed to delete vehicles. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };
  



// Modify checkFormValidity to conditionally require vehicles based on if it's an update or not
const checkFormValidity = (currentFormData) => {
  // Remove email from mandatory fields
  const mandatoryFields = ['userName', 'mobile', 'desigCode', 'currentBranchId', 'roleCode', 'area', 'companyCode'];
  const isValid = mandatoryFields.every(field => {
    const validationError = validateField(field, currentFormData[field]);
    return !validationError;
  });
  
  // Only require vehicles for new users (not for updates)
  // const isUpdate = !!initialData;
  
  // Count only non-deleted vehicles
  const activeVehiclesCount = vehicles.filter(v => v.dml !== "D").length;
  const hasVehicles = activeVehiclesCount > 0;
  
  // const vehiclesValid = isUpdate || hasVehicles;
  
  setIsFormValid(isValid );
  return isValid ;
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFormData = { ...formData, [name]: value };
    
    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, value)
    }));

    setFormData(newFormData);
    checkFormValidity(newFormData);
  };



  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await fetch(`${local_signage}/api/v1/role`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('AuthorizationToken')}`,
            'Content-Type': 'application/json'
          }
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const data = await response.json();
        setRoles(data);
      } catch (error) {
        console.error('Error fetching roles:', error);
        setSnackbar({
          open: true,
          message: 'Failed to fetch roles',
          severity: 'error'
        });
      }
    };
  
    fetchRoles();
  }, []);



  const validate = () => {
    let tempErrors = {};
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) tempErrors[key] = error;
    });
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const fetchLedgerData = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const response = await fetch(`${local_url}/api/Company/GetCompanyList`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setLedgerData(data);
    } catch (error) {
      setError("Failed to fetch company data. Please try again later.");
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedgerData();
    
    const fetchAreas = async () => {
      try {
        const response = await fetch(`${local_url}/api/SFArea/${userId}`);
        const data = await response.json();
        setAreas(data);
      } catch (error) {
        console.error('Error fetching areas:', error);
      }
    };
    fetchAreas();
  }, [userId]);

// Modify the handleAreaChange function to preserve the current branch if it exists in the new branch list
const handleAreaChange = async (event) => {
  const token = localStorage.getItem('AuthorizationToken');
  const selectedArea = event.target.value;
  setFormData(prev => ({ ...prev, area: selectedArea }));

  try {
    const response = await fetch(`${local_url}/api/Company/GetBranchList/ALL/AREA/${selectedArea}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();
    setBranchList(data);
    
    // Check if the current branch exists in the new branch list
    if (selectedBranch) {
      const branchExistsInNewList = data.some(branch => branch.branchID === selectedBranch.branchID);
      if (!branchExistsInNewList) {
        // Only reset the branch if it doesn't exist in the new list
        setSelectedBranch(null);
        setBranchInputValue('');
        setFormData(prev => ({
          ...prev,
          currentBranchId: '',
          defaultLoginBranchId: ''
        }));
      }
      // If the branch exists in the new list, keep it selected
    }
  } catch (error) {
    console.error('Error fetching branches:', error);
    setSnackbar({
      open: true,
      message: 'Failed to fetch branches for selected area',
      severity: 'error'
    });
  }
};


  // Fetch designations
  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const response = await fetch(`${local_signage}/api/v1/desigination?DesigType=VEHST`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('AuthorizationToken')}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setDesignations(data);
      } catch (error) {
        console.error('Error fetching designations:', error);
        setSnackbar({
          open: true,
          message: 'Failed to fetch designations',
          severity: 'error'
        });
      }
    };

    fetchDesignations();
  }, []);



  
// Add a separate useEffect to handle designation updates when designations are loaded
useEffect(() => {
  if (formData.desigCode && designations.length > 0) {
    const matchingDesignation = designations.find(
      desig => desig.DesigCode === formData.desigCode
    );
    if (matchingDesignation) {
      setSelectedDesignation(matchingDesignation);
      setDesignationInputValue(matchingDesignation.DesigName);
    }
  }
}, [formData.desigCode, designations]);
  
// Update the useEffect that fetches employee details to handle designation name properly
useEffect(() => {
  const fetchEmployeeDetails = async () => {
    if (initialData?.userid) {
      setIsLoading(true);
      try {
        const response = await fetch(`${local_signage}/api/v1/contractemployee?UserId=${initialData.userid}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('AuthorizationToken')}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setApiData(data);
        
        // Handle Vehicles data
        if (data.UserVehicles && Array.isArray(data.UserVehicles)) {
          const formattedVehicles = data.UserVehicles.map(vehicle => ({
            userId: vehicle.UserId || initialData.userid,
            lineNumber: vehicle.LineNumber || '',
            vehicleId: vehicle.VehicleId || '',
            vehicleAlias: vehicle.VehicleAlias || '',
            createdUserId: vehicle.CreatedUserId ? vehicle.CreatedUserId.trim() : '',
            createdDate: vehicle.CreatedDate || new Date().toISOString(),
            dml: "E",
          }));
          
          setVehicles(formattedVehicles);
          
          const maxLineNumber = Math.max(
            ...formattedVehicles.map(v => parseInt(v.lineNumber, 10) || 0),
            0
          );
          setNextLineNumber(maxLineNumber + 1);
        }

        if (data.EmployeeDetails && data.EmployeeDetails[0]) {
          const employeeData = data.EmployeeDetails[0];
          
          // Set form data
          setFormData({
            userID: employeeData.userid || '',
            userName: employeeData.UserName || '',
            fatherName: employeeData.FatherName || '',
            companyCode: employeeData.CompanyCode || '',
            currentBranchId: employeeData.CurrentBranchId || '',
            defaultLoginBranchId: employeeData.DefaultLoginBranchId || '',
            roleCode: employeeData.RoleCode || '',
            desigCode: employeeData.DesigCode || '',
            mobile: employeeData.Mobile || '',
            email: employeeData.Email || '',
            isActive: employeeData.IsActive,
            dob: employeeData.DOB ? dayjs(employeeData.DOB) : null,
            joindate: employeeData.JDate ? dayjs(employeeData.JDate) : null,
            area: employeeData.AreaId || ''
          });

          // If we have a designation code but no designations loaded yet, 
          // wait for designations to be fetched
          if (employeeData.DesigCode && designations.length > 0) {
            const matchingDesignation = designations.find(
              desig => desig.DesigCode === employeeData.DesigCode
            );
            if (matchingDesignation) {
              setSelectedDesignation(matchingDesignation);
              setDesignationInputValue(matchingDesignation.DesigName);
            }
          }

          // Fetch branches for the current branch
          if (employeeData.CurrentBranchId) {
            const token = localStorage.getItem('AuthorizationToken');
            const branchResponse = await fetch(
              `${local_url}/api/Company/GetBranchList/ALL/AREA/ALL`,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              }
            );
            
            if (branchResponse.ok) {
              const branchData = await branchResponse.json();
              setBranchList(branchData);

              const matchingBranch = branchData.find(
                branch => branch.branchID === employeeData.CurrentBranchId
              );
              if (matchingBranch) {
                setSelectedBranch(matchingBranch);
                setBranchInputValue(matchingBranch.branchName);
              }
            }
          }
        }

      } catch (error) {
        console.error('Error fetching employee details:', error);
        setSnackbar({
          open: true,
          message: 'Failed to fetch employee details',
          severity: 'error'
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  fetchEmployeeDetails();
}, [initialData?.userid, designations]); // Added designations as a dependency


const handleDesignationChange = (event, newValue) => {
  setSelectedDesignation(newValue);
  
  setFormData(prev => ({
    ...prev,
    desigCode: newValue ? newValue.DesigCode : ''
  }));
  
  setErrors(prev => ({
    ...prev,
    desigCode: newValue ? '' : 'Designation is required'
  }));

  checkFormValidity({
    ...formData,
    desigCode: newValue ? newValue.DesigCode : ''
  });
};


// Add a useEffect to check form validity when vehicles change
// Add a useEffect to check form validity when vehicles change
useEffect(() => {
  checkFormValidity(formData);
}, [vehicles, initialData]); // Added initialData as dependency



const handleVehicleInputChange = (e) => {
  const { name, value } = e.target;
  setNewVehicleData(prev => ({ ...prev, [name]: value }));
  
  // Clear error when user starts typing
  setVehicleError(prev => ({ ...prev, [name]: '' }));
  
  // If this is vehicle alias, check for duplicates
  if (name === 'vehicleAlias' && value.trim()) {
    const isDuplicate = vehicles.some(v => 
      v.vehicleAlias.toLowerCase() === value.trim().toLowerCase()
    );
    
    if (isDuplicate) {
      setVehicleError(prev => ({ 
        ...prev, 
        vehicleAlias: 'This vehicle alias already exists' 
      }));
    }
  }
};



const handleAddVehicle = () => {
  // Check for duplicate vehicle alias
  const vehicleAlias = newVehicleData.vehicleAlias.trim();
  const isDuplicate = vehicles.some(v => 
    v.vehicleAlias.toLowerCase() === vehicleAlias.toLowerCase()
  );
  
  if (isDuplicate) {
    setVehicleError(prev => ({ 
      ...prev, 
      vehicleAlias: 'This vehicle alias already exists' 
    }));
    return;
  }

  // Find next available line number (maximum + 1)
  const maxLineNumber = vehicles.length > 0 
    ? Math.max(...vehicles.map(v => parseInt(v.lineNumber, 10) || 0))
    : 0;
  
  const nextLineNum = (maxLineNumber + 1).toString().padStart(3, '0');
  
  const newVehicle = {
    userId: formData.userID || initialData?.userid || 'string',
    lineNumber: nextLineNum,
    vehicleId: '0000000000',
    vehicleAlias: vehicleAlias,
    createdUserId: userId || 'system',
    createdDate: new Date().toISOString(),
    dml: "I"
  };
  
  setVehicles(prev => [...prev, newVehicle]);
  handleCloseVehicleModal();
};


  const handleCloseVehicleModal = () => {
    setIsVehicleModalOpen(false);
    setNewVehicleData({
      vehicleId: '',
      vehicleAlias: '',
      lineNumber: ''
    });
    setVehicleError({});
  };

  const handleOpenVehicleModal = () => {
    setIsVehicleModalOpen(true);
  };




  // Add this function to your existing validation functions
const validateJoiningDate = (joinDate, birthDate) => {
  if (!joinDate || !birthDate) return ""; // If either date is missing, no validation needed yet
  
  // Convert to native Date objects for comparison
  const join = joinDate.toDate();
  const birth = birthDate.toDate();
  
  // Check if join date is same or before birth date
  if (join <= birth) {
    return "Joining date must be after date of birth";
  }
  return "";
};









  const handleBranchChange = (event, newValue) => {
    setSelectedBranch(newValue);
    if (newValue) {
      setFormData(prev => ({
        ...prev,
        currentBranchId: newValue.branchID,
        defaultLoginBranchId: newValue.branchID
      }));
    }
  };

  const handleDateChange = (name, value) => {
    setFormData(prev => {
      const newFormData = { ...prev, [name]: value };
      
      // If either date changed, validate the joining date
      if (name === 'dob' || name === 'joindate') {
        const joinDateError = validateJoiningDate(newFormData.joindate, newFormData.dob);
        setErrors(prev => ({
          ...prev,
          joindate: joinDateError
        }));
      }
      
      return newFormData;
    });
    
    // Check form validity with updated dates
    checkFormValidity({...formData, [name]: value});
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      // Include all vehicles in the payload, including those marked for deletion
      const vehiclesPayload = vehicles.map(v => ({
        ...v,
        userId: formData.userID || initialData?.userid
      }));
  
      const payload = {
        ...formData,
        vehicle: vehiclesPayload,
        createdUserId: userId || 'system',
        createdDate: new Date().toISOString(),
        dob: formData.dob?.toISOString(),
        joindate: formData.joindate?.toISOString()
      };
  
      const response = await fetch(`${local_url}/api/User/CreateEditUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('AuthorizationToken')}`
        },
        body: JSON.stringify(payload)
      });
  
      const responseData = await response.json();
  
      if (!response.ok || responseData.result === 0) {
        throw new Error(responseData.description || 'Failed to save user');
      }
  
      setSnackbar({
        open: true,
        message: responseData.description || `User ${initialData ? 'updated' : 'created'} successfully!`,
        severity: 'success'
      });
  
      setTimeout(() => {
        onClose();
      }, 1000);
    } catch (error) {
      console.error('Error saving user:', error);
  
      setSnackbar({
        open: true,
        message: error.message || 'Failed to save user. Please try again.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };
  
  

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
       {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
      <Box sx={{ bgcolor: 'background.default' }}>
        <FormContainer>
          <StyledCard>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={6} sm={4}>
                    <TextField
                      fullWidth
                      label="User ID"
                      name="userID"
                      disabled='True'
                      value={formData.userID}
                      onChange={handleChange}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="userName"
                      value={formData.userName}
                      onChange={handleChange}
                      error={!!errors.userName}
                      helperText={errors.userName}
                      variant="outlined"
                      required
                    />
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <TextField
                      fullWidth
                      label="Father's Name"
                      name="fatherName"
                      value={formData.fatherName}
                      onChange={handleChange}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={6} sm={4}>
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        variant="outlined"
                        // Remove required prop
                        onBlur={(e) => {
                          const error = validateField('email', e.target.value);
                          setErrors(prev => ({ ...prev, email: error }));
                        }}
                      />
                    </Grid>

                  <Grid item xs={6} sm={4}>
                    <TextField
                      fullWidth
                      label="Mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      error={!!errors.mobile}
                      helperText={errors.mobile}
                      variant="outlined"
                      required
                      inputProps={{
                        maxLength: 10,
                        pattern: '[0-9]*'
                      }}
                      onBlur={(e) => {
                        const error = validateField('mobile', e.target.value);
                        setErrors(prev => ({ ...prev, mobile: error }));
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <FormControl fullWidth error={!!errors.area}>
                      <InputLabel>Area</InputLabel>
                      <Select
                        name="area"
                        value={formData.area}
                        onChange={handleAreaChange}
                        label="Area"
                        required
                      >
                        <MenuItem value="">Select Area</MenuItem>
                        {areas.map((area) => (
                          <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
                            {area.sfAreaName}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.area && (
                        <FormHelperText>{errors.area}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

      
                  <Grid item xs={6} sm={4}>
                  <Autocomplete
  fullWidth
  disabled={!formData.area && !initialData?.userid}
  options={[{ branchID: "ALL", branchName: "ALL" }, ...branchList]}
  getOptionLabel={(option) => option.branchName || ""}
  value={selectedBranch}
  onChange={handleBranchChange}
  inputValue={branchInputValue}
  onInputChange={(event, newInputValue) => {
    setBranchInputValue(newInputValue);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Branch"
      variant="outlined"
      error={!!errors.currentBranchId}
      helperText={!formData.area && !initialData?.userid
        ? "Please select an Area to change branch" 
        : errors.currentBranchId}
      required
    />
  )}
  isOptionEqualToValue={(option, value) => option.branchID === value?.branchID}
/>
</Grid>

                  <Grid item xs={6} sm={4}>
                    <FormControl fullWidth error={!!errors.companyCode}>
                      <InputLabel>Company Code</InputLabel>
                      <Select
                        name="companyCode"
                        value={formData.companyCode}
                        onChange={handleChange}
                        label="Company Code"
                      >
                        <MenuItem value="">Select Company</MenuItem>
                        {ledgerData.map((company) => (
                          <MenuItem key={company.entityCode} value={company.entityCode}>
                            {company.entityName}
                          </MenuItem>
                        ))}
                      </Select>
                      {error && (
                        <FormHelperText error>{error}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

              <Grid item xs={6} sm={4}>
  <FormControl fullWidth error={!!errors.roleCode}>
    <InputLabel>Role</InputLabel>
    <Select
      name="roleCode"
      value={formData.roleCode}
      onChange={handleChange}
      label="Role"
      required
    >
      <MenuItem value="">Select Role</MenuItem>
      {roles.map(role => (
        <MenuItem key={role.RoleCode} value={role.RoleCode}>
          {role.RoleName}
        </MenuItem>
      ))}
    </Select>
    {errors.roleCode && (
      <FormHelperText>{errors.roleCode}</FormHelperText>
    )}
  </FormControl>
</Grid>



{/* New Designation Autocomplete field */}
<Grid item xs={6} sm={4}>
  <Autocomplete
    fullWidth
    options={designations}
    getOptionLabel={(option) => option.DesigName || ""}
    value={designations.find(d => d.DesigCode === formData.desigCode) || null} // Ensures correct binding
    onChange={handleDesignationChange}
    inputValue={designationInputValue}
    onInputChange={(event, newInputValue) => {
      setDesignationInputValue(newInputValue);
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Designation"
        variant="outlined"
        error={!!errors.desigCode}
        helperText={errors.desigCode}
        required
      />
    )}
    isOptionEqualToValue={(option, value) => option.DesigCode === value?.DesigCode}
  />
</Grid>



                  <Grid item xs={6} sm={4}>
                    <DatePicker
                      label="Date of Birth"
                      value={formData.dob}
                      format="DD-MM-YYYY"
                      onChange={(newValue) => handleDateChange('dob', newValue)}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: 'outlined'
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} sm={4}>
  <DatePicker
    label="Joining Date"
    format="DD-MM-YYYY"
    value={formData.joindate}
    onChange={(newValue) => handleDateChange('joindate', newValue)}
    slotProps={{
      textField: {
        fullWidth: true,
        variant: 'outlined',
        error: !!errors.joindate,
        helperText: errors.joindate
      }
    }}
  />
</Grid>

                  <Grid item xs={6} sm={4}>
                    <FormControl fullWidth>
                      <InputLabel>Is Active</InputLabel>
                      <Select
                        name="isActive"
                        value={formData.isActive}
                        onChange={handleChange}
                        label="isActive"
                      >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                
                  <Grid item xs={12}>
  <Box sx={{ mt: 4 }}>
  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  <Typography variant="h6">Vehicles</Typography>
  <Box>
  <Button
      variant="contained"
      startIcon={<Plus size={20} />}
      onClick={handleOpenVehicleModal}
      sx={{ mr: 1 }}
    >
      Add Vehicle
    </Button>
  </Box>
</Box>

<TableContainer component={Paper}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        <TableCell>Line No.</TableCell>
        <TableCell>Vehicle ID</TableCell>
        <TableCell>Vehicle Alias</TableCell>
        <TableCell>Created Date</TableCell>
        <TableCell>Status</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {vehicles && vehicles.length > 0 ? (
        vehicles
          .filter(vehicle => vehicle.dml !== "D") // Only show non-deleted vehicles
          .map((vehicle, index) => (
            <TableRow 
              key={index}
              hover
              sx={{ 
                cursor: 'pointer',
                // Disable row if in selection mode and this vehicle is of a different type
              }}
            >
              <TableCell padding="checkbox">
                <input
                  type="checkbox"
                  onChange={() => handleVehicleCheckboxChange(index)}

                />
              </TableCell>
              <TableCell>{vehicle.lineNumber}</TableCell>
              <TableCell>{vehicle.vehicleId}</TableCell>
              <TableCell>{vehicle.vehicleAlias}</TableCell>
              <TableCell>
                {vehicle.createdDate 
                  ? new Date(vehicle.createdDate).toLocaleDateString()
                  : 'N/A'}
              </TableCell>
              <TableCell>
                {vehicle.dml === "I" ? "New" : vehicle.dml === "E" ? "Updated" : ""}
              </TableCell>
            </TableRow>
          ))
      ) : (
        <TableRow>
          <TableCell colSpan={6} align="center">
            No vehicles added
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>

  </Box>
</Grid>

<Grid item xs={12}>
<Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
  <Button variant="outlined" onClick={onClose}>
    Cancel
  </Button>
  <Button
      variant="outlined"
      color="error"
      onClick={handleDeleteVehicles}
      disabled={!vehicles.some(v => v.selected)}
      startIcon={<X size={20} />}
    >
      Delete Selected
    </Button>
  <Button
    type="submit"
    variant="contained"
    color="primary"
    disabled={loading || (!isFormValid && !initialData)}
  >
    {loading ? 'Saving...' : initialData ? 'Update' : 'Create'}
  </Button>
</Box>
</Grid>
                </Grid>
              </form>
            </CardContent>
          </StyledCard>
        </FormContainer>

        <Dialog open={isVehicleModalOpen} onClose={handleCloseVehicleModal}>
          <DialogTitle>
            Add Vehicle
            <IconButton
              onClick={handleCloseVehicleModal}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'grey.500'
              }}
            >
              <X size={20} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2, minWidth: '300px' }}>
           
              <TextField
                fullWidth
                label="Vehicle Alias"
                name="vehicleAlias"
                value={newVehicleData.vehicleAlias}
                onChange={handleVehicleInputChange}
                inputProps={{
                  maxLength: 10,
                }}
                error={!!vehicleError.vehicleAlias}
                helperText={vehicleError.vehicleAlias}
                variant="outlined"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseVehicleModal}>Cancel</Button>
            <Button 
  variant="contained" 
  onClick={handleAddVehicle}
  disabled={
    newVehicleData.vehicleAlias.trim().length !== 10 || 
    !!vehicleError.vehicleAlias
  }
>
  Add
</Button>

          </DialogActions>
        </Dialog>


        <Snackbar
  open={snackbar.open}
  autoHideDuration={4000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
>
  <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
    {snackbar.message}
  </Alert>
</Snackbar>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
      )}
    </LocalizationProvider>
  );
};

export default UserRegistrationForm;
































































// import React, { useState, useEffect } from "react";
// import { Header } from "../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import Grid from "@mui/material/Grid";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import Pagination from "@mui/material/Pagination";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
// import "./Reports.css";
// import { local_url } from "../Const";
// import { saveAs } from "file-saver";

// const Reports = () => {
//   const [areas, setAreas] = useState([]);
//   const [area, setArea] = useState("ALL");
//   const [startDate, setStartDate] = useState(dayjs());
//   const [endDate, setEndDate] = useState(dayjs());
//   const [type, setType] = useState("ALL");
//   const [page, setPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [error, setError] = useState(null);
//   const [areasLoading, setAreasLoading] = useState(true);
//   const userId = localStorage.getItem('userId');
//   const rowsPerPage = 100;
//   const [division, setDivision] = useState("POULTRY"); // Add new state for division

//   const transformWeeklyData = (data) => {
//     // First filter by selected division
//     const filteredData = data.filter(item => item.Division === division);
  
//     // Mapping SalesChannel categories
//     const channelMapping = {
//       "APP": "Online",
//       "WEB": "Online",
//       "POS": "Offline",
//       "CAL": "Offline",
//       "GT": "GT / MT",
//       "MT": "GT / MT",
//       "MP": "MP"
//     };
  
//     // Group by Area and SalesChannel category
//     const groupedData = filteredData.reduce((acc, item) => {
//       const key = item.Area || '';
//       const category = channelMapping[item.SalesChannel] || 'Others';
  
//       if (!acc[key]) {
//         acc[key] = {
//           CITYID: item.Area,
//           channels: {
//             "Online": { 1: 0, 2: 0, 3: 0, 4: 0 },
//             "Offline": { 1: 0, 2: 0, 3: 0, 4: 0 },
//             "GT / MT": { 1: 0, 2: 0, 3: 0, 4: 0 },
//             "MP": { 1: 0, 2: 0, 3: 0, 4: 0 }
//           }
//         };
//       }
  
//       if (!acc[key].channels[category]) {
//         acc[key].channels[category] = { 1: 0, 2: 0, 3: 0, 4: 0 };
//       }
  
//       const weekNum = parseInt(item.WeekNum) || 1;
//       const qty = parseFloat(item.Qty) || 0;
//       const returnQty = parseFloat(item.ReturnQty) || 0;
  
//       if (weekNum >= 1 && weekNum <= 4) {
//         acc[key].channels[category][weekNum] = 
//           (acc[key].channels[category][weekNum] || 0) + (qty - returnQty);
//       }
  
//       return acc;
//     }, {});
  
//     // Transform into final format
//     return Object.entries(groupedData).flatMap(([cityId, data]) => {
//       return Object.entries(data.channels).map(([channel, weeks]) => {
//         const week1 = (weeks[1] || 0).toFixed(2);
//         const week2 = (weeks[2] || 0).toFixed(2);
//         const week3 = (weeks[3] || 0).toFixed(2);
//         const week4 = (weeks[4] || 0).toFixed(2);
  
//         return {
//           CITYID: cityId,
//           Category: channel,
//           'Week 1': week1,
//           'Week 2': week2,
//           'Week 3': week3,
//           'Week 4': week4,
//           DIFF: (Number(week4) - Number(week3)).toFixed(2)
//         };
//       });
//     });
//   };
  


//   useEffect(() => {
//     const fetchAreas = async () => {
//       setAreasLoading(true);
//       setError(null);

//       try {
//         const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         const data = await response.json();
//         setAreas(Array.isArray(data) ? data : []);
//       } catch (error) {
//         setError(`Failed to fetch areas: ${error.message}`);
//       } finally {
//         setAreasLoading(false);
//       }
//     };

//     fetchAreas();
//   }, [local_url, userId]);

//   const fetchReportData = async () => {
//     setLoading(true);
//     setError(null);
    
//     const token = localStorage.getItem('AuthorizationToken');
//     if (!token) {
//       setError("Authorization token not found. Please login again.");
//       setLoading(false);
//       return;
//     }
  
//     try {
//       const formattedStartDate = startDate.format('YYYYMMDD');
//       const formattedEndDate = endDate.format('YYYYMMDD');
      
//       const url = `https://tpapi.abisaio.com:3060/api/v1/b2csaleqty?Option=PIVOT&AreaID=${area}&SaleChannel=${type}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`;
      
//       const response = await fetch(url, {
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//       });
  
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       const transformedData = transformWeeklyData(data);
//       setTableData(transformedData.sort((a, b) => a.CITYID.localeCompare(b.CITYID)));

//     } catch (error) {
//       setError(error.message || "Failed to fetch report data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleExport = () => {
//     const csvRows = [
//       ['CITYID', 'Category', 'Week 1', 'Week 2', 'Week 3', 'Week 4', 'DIFF'],
//       ...tableData.map(item => [
//         item.CITYID,
//         item.Category,
//         item['Week 1'],
//         item['Week 2'],
//         item['Week 3'],
//         item['Week 4'],
//         item.DIFF
//       ])
//     ];

//     const csvString = csvRows
//       .map(row => row.map(cell => 
//         typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell
//       ).join(','))
//       .join('\n');

//     const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//     const fileName = `weekly_report_${startDate.format('YYYYMMDD')}_${endDate.format('YYYYMMDD')}.csv`;
//     saveAs(blob, fileName);
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const startIndex = (page - 1) * rowsPerPage;
//   const endIndex = startIndex + rowsPerPage;
//   const paginatedData = tableData.slice(startIndex, endIndex);

//   return (
//     <div className="report-container">
//       <Header />
//       <Card className="report-card">
//         <CardContent>
//           <Grid container spacing={2} alignItems="center" justifyContent="space-between">
//             <Grid item xs={12} sm={6} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Area</InputLabel>
//                 <Select
//                   value={area}
//                   onChange={(e) => setArea(e.target.value)}
//                   label="Area"
//                   disabled={areasLoading}
//                 >
//                   <MenuItem value="ALL">ALL</MenuItem>
//                   {areas.map((area) => (
//                     <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
//                       {area.sfAreaName}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <DatePicker 
//                   label="Start Date" 
//                   value={startDate} 
//                   onChange={(newValue) => setStartDate(newValue)} 
//                   fullWidth 
//                 />
//               </LocalizationProvider>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                 <DatePicker 
//                   label="End Date" 
//                   value={endDate} 
//                   onChange={(newValue) => setEndDate(newValue)} 
//                   fullWidth 
//                 />
//               </LocalizationProvider>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Division</InputLabel>
//                 <Select
//                   value={division}
//                   onChange={(e) => setDivision(e.target.value)}
//                   label="Division"
//                 >
//                   <MenuItem value="POULTRY">POULTRY</MenuItem>
//                   <MenuItem value="NONPOULTRY">NONPOULTRY</MenuItem>
//                   <MenuItem value="EGG">EGG</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Search Button */}
//             <Grid item xs={12} sm={6} md={3}>
//               <Button variant="contained" color="primary" fullWidth onClick={fetchReportData}>
//                 Search
//               </Button>
//             </Grid>

//             {/* Export Button */}
//             <Grid item xs={12} sm={6} md={3}>
//               <Button variant="contained" color="secondary" fullWidth onClick={handleExport}>
//                 Export
//               </Button>
//             </Grid>
//           </Grid>

//           {error && <div className="error-message">{error}</div>}

//           <div className="report-table-container">
//             <div className="report-table-scroll">
//               <table className="report-table">
//                 <thead>
//                   <tr>
//                     <th>Region</th>
//                     <th>Channel</th>
//                     <th>Week 1</th>
//                     <th>Week 2</th>
//                     <th>Week 3</th>
//                     <th>Week 4</th>
//                     <th>DIFF</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={7} className="report-loading">
//                         <CircularProgress />
//                       </td>
//                     </tr>
//                   ) : paginatedData.length > 0 ? (
//                     [...paginatedData].sort((a, b) => a.CITYID.localeCompare(b.CITYID)).map((item, index) => (

//                       <tr key={index}>
//                         <td>{item.CITYID}</td>
//                         <td>{item.Category}</td>
//                         <td>{item['Week 1']}</td>
//                         <td>{item['Week 2']}</td>
//                         <td>{item['Week 3']}</td>
//                         <td>{item['Week 4']}</td>
//                         <td className={Number(item.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//                           {item.DIFF}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={7} className="report-no-data">
//                         No data available
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             {tableData.length > 0 && (
//               <div className="report-pagination">
//                 <div className="report-pagination-info">
//                   Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of {tableData.length} entries
//                 </div>
//                 <Pagination 
//                   count={Math.ceil(tableData.length / rowsPerPage)} 
//                   page={page} 
//                   onChange={handlePageChange} 
//                   color="primary" 
//                   shape="rounded" 
//                 />
//               </div>
//             )}
//           </div>
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

// export default Reports;